import axios from "axios";
import { API_BASE_URL } from "@/lib/apiBase";

export const INTEREST_BANNER_STORAGE_KEY = "circa.interestBannerDismissed";

export function isInterestBannerDismissed() {
  try {
    return localStorage.getItem(INTEREST_BANNER_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissInterestBanner() {
  try {
    localStorage.setItem(INTEREST_BANNER_STORAGE_KEY, "1");
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * Public closed-beta interest submission.
 * @param {{ email: string, body?: string }} payload
 */
export async function postInterest({ email, body }) {
  const res = await axios.post(`${API_BASE_URL}/interest`, {
    email,
    ...(body != null && String(body).trim()
      ? { body: String(body).trim() }
      : {}),
  });
  return res.data;
}
